/*
 * @@Description: 普通table
 * @@Author: MuYang
 * @Date: 2021-07-28 10:57:30
 * @LastEditTime: 2021-10-19 17:19:29
 */
import T from './components/index'
import { TableProps } from './util/default-props'
import openEvent from './mixin/open-event'
export default {
  name: 'DTable',
  components: { T },
  props: TableProps,
  mixins: [openEvent],
  data () {
    return {}
  },
  created () {
    // 加工基础table 需要的数据
  },
  methods: { },
  render (h) {
    // 初始化
    const { $props, $scopedSlots, $slots } = this
    const tProps = {
      props: $props,
      scopedSlots: $scopedSlots,
      slots: $slots
    }
    return <T {...tProps}>{ $slots }</T>
  }
}
